import React, { type ReactNode } from 'react';
import styled from 'types/theme.types';
import { Route, Routes } from 'react-router-dom';
import TopBar from 'components/layout/topbar/topbar';
import AnnouncementBanner from 'components/announcement-banner/announcement-banner';

export const MainLayout: React.FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <OuterContainer>
      <Routes>
        {['/p/:projectId/*', '/*'].map(path => (
          <Route key={path} path={path} element={<TopBar page={path} />} />
        ))}
      </Routes>
      <AnnouncementBanner />
      <MainLayoutContainer>{children}</MainLayoutContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.primaryWhite};
  flex: 1;
  max-height: 100%;
  overflow: hidden;
`;

export default MainLayout;
